<div class="kiene-content-page">
    <kiene-kiene-table [tableDescriptor]="tableDescriptor"></kiene-kiene-table>
</div>
